import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import type { PlansModalProps } from "./PlansModalBody";
import { PlansModalCompass } from "./PlansModalCompass";
import { PlansModalUIKitComponent } from "./PlansModalUIKitComponent";

const PlansModalComponent = (props: PlansModalProps) => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");

  if (!isCircleV4) {
    return <PlansModalUIKitComponent {...props} />;
  }

  return <PlansModalCompass {...props} />;
};

const PlansModal = ModalManager.create((props: PlansModalProps) => (
  <PlansModalComponent {...props} />
));

export const usePlansModal = () => useModal(PlansModal);
